/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Popup, TextBox } from "devextreme-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import "./saveGridTemplate.css";
import { confirm, alert } from 'devextreme/ui/dialog';
import { CloneGridTemplateDialog } from "./GridTemplateClone/cloneGridTemplate";
import { GridTemplatesGrid } from "./SaveGridTemplatedGrid";
import ShareGridTemplateDialog from "./GridTemplateShare/ShareGridTemplate";
import { deleteGridTemplate, getGridTemplatesByUserProgramCategory, postGridTemplate, setSelectedTemplate, updateExistingTemplate, updateTemplateName } from "../../../../actions/gridTemplates/gridTemplatesActions";
import PropTypes from "prop-types";
import { renderButtons } from "./Functions/RenderButtons";
import { LinearProgress } from "@mui/material";

export const SaveGridTemplateDialog = (props) => {
    const { open, onClose, userId, programId, categoryId, storageKey, onTemplateChange, gridInstance } = props;
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const programs = useSelector(state => state?.userInfo.programs);
    const categories = useSelector(state => state?.userInfo.categories);

    // Log gridInstance availability for debugging
    console.log('SaveGridTemplateDialog gridInstance available:', !!gridInstance?.current?.instance);


    const [state, setState] = useState({ "templateName": "", selectedTemplateId: 0, "open": { "showCloneGridTemplate": false, "showShareGridTemplate": false } });



    async function getGridData() {
        const response = await getGridTemplatesByUserProgramCategory(userId, programId, categoryId);
        setTemplates(response);
        setIsLoadingData(false);
    };

    useEffect(() => {
        setIsLoadingData(true);
        getGridData();
    }, [userId, programId, categoryId, open]);

    const getCurrentTemplate = (templates) => {
        if (templates) {
            let currentTemplate = templates.find(x => x.selected === true);
            return currentTemplate?.templateName;
        }
        return ""
    }

    const valueChanged = (data) => {
        setState({ ...state, templateName: data.value });
    }

    const updateSelectedTemplateData = async (id, template) => {
        try {
            if (template && template.selected) {
                // Parse template if it's a string, or use it directly if it's already an object
                let parsedTemplate = template.template;
                if (typeof template.template === 'string') {
                    try {
                        parsedTemplate = JSON.parse(template.template);
                    } catch (parseError) {
                        console.error('Error parsing template:', parseError);
                        setLoading(false);
                        return;
                    }
                }
                
                localStorage.setItem(storageKey, JSON.stringify(parsedTemplate));
                onTemplateChange(parsedTemplate);
                await setSelectedTemplate(id, true);
            } else {
                // Template deselected - reset to default
                console.log('Template deselected - clearing template data');
                localStorage.removeItem(storageKey);
                onTemplateChange(null);
                await setSelectedTemplate(id, false);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error updating selected template:', error);
            setLoading(false);
        }
    }


    const switchTemplate = async (id) => {
        console.log('switchTemplate called with id:', id);
        setLoading(true);
        
        try {
            const updatedTemplates = templates.map((template) => ({
                ...template,
                selected: template.id === id ? !template.selected : false,
            }));
            setTemplates(updatedTemplates);
            const selectedTemplate = updatedTemplates.find((template) => template.id === id);
            console.log('Selected template:', selectedTemplate);
            
            // Check if any template is now selected
            const hasAnySelected = updatedTemplates.some(template => template.selected);
            
            if (!hasAnySelected) {
                // No template selected - reset to default state
                console.log('No template selected - resetting to default state');
                localStorage.removeItem(storageKey);
                onTemplateChange(null);
                
                // Also clear any selected template on the server
                await setSelectedTemplate(id, false);
                
                // Reset loading state
                setLoading(false);
            } else {
                // A template is selected - apply it
                await updateSelectedTemplateData(id, selectedTemplate);
            }
        } catch (error) {
            console.error('Error in switchTemplate:', error);
            setLoading(false);
        }
    };

    const showCloneGridTemplateDialog = (templateId) => {
        setState({
            ...state, open: {
                ...state.open, showCloneGridTemplate: true
            }, selectedTemplateId: templateId

        });

    }

    const showShareGridTemplateDialog = (templateId) => {
        setState({
            ...state, open: {
                ...state.open, showShareGridTemplate: true
            }, selectedTemplateId: templateId

        });
    }

    async function updateGridTemplateConfiguration(id) {
        try {
            // Force save the current grid state first if gridInstance is available
            if (gridInstance?.current?.instance) {
                try {
                    const currentGridState = gridInstance.current.instance().state();
                    if (currentGridState && typeof currentGridState === 'object') {
                        const stateString = JSON.stringify(currentGridState);
                        localStorage.setItem(storageKey, stateString);
                        console.log('Forced save of current grid state before template update');
                    }
                } catch (gridStateError) {
                    console.error('Error getting current grid state:', gridStateError);
                }
            }
            
            // Get current state from localStorage (which now contains the most recent grid state)
            const currentStateString = localStorage.getItem(storageKey);
            if (!currentStateString) {
                alert("No current grid state found to save", "Error");
                return;
            }
            
            // Validate the template data before saving
            let currentState;
            try {
                currentState = JSON.parse(currentStateString);
            } catch (parseError) {
                console.error('Error parsing current state:', parseError);
                alert("Invalid template data found", "Error");
                return;
            }
            
            console.log('Updating template with current state:', currentState);
            await updateExistingTemplate(id, currentStateString);
            await getGridData();
        } catch (error) {
            console.error('Error updating template configuration:', error);
            alert("Failed to update template", "Error");
        }
    }

    const updateGridTemplateDialog = async (id) => {
        const dialogResult =  await confirm("<i>Are you sure you want to update this template?</i>", "Confirm template update");
            if (dialogResult) {
                await updateGridTemplateConfiguration(id);
                alert("Template updated successfully", "Success");
            }
    }

    const deleteTemplate = async (id) => {
        const confirmDelete = confirm("<i>Are you sure you want to delete the template for this program and category?</i>", "Confirm template delete");
        confirmDelete.then((dialogResult) => {
            if (dialogResult) {
                const newState = templates.filter(x => x.id !== id);
                setTemplates(newState);
                deleteGridTemplate(id);
            }
        }
        );
    }

    const updateGridTemplateName = (data) => {
        updateTemplateName(data.data.id, data.data.templateName);
    }

    const saveColumnConfiguration = async () => {

        if (state.templateName === "") {
            alert("Template name is required", "Error");
        }
        else {
            try {
                // Force save the current grid state first if gridInstance is available
                if (gridInstance?.current?.instance) {
                    try {
                        const currentGridState = gridInstance.current.instance().state();
                        if (currentGridState && typeof currentGridState === 'object') {
                            const stateString = JSON.stringify(currentGridState);
                            localStorage.setItem(storageKey, stateString);
                            console.log('Forced save of current grid state before new template save');
                        }
                    } catch (gridStateError) {
                        console.error('Error getting current grid state:', gridStateError);
                    }
                }
                
                const currentState = localStorage.getItem(storageKey); 
                if (currentState === null || currentState === "") {
                    alert("No template to save. Please make some changes to the grid first.", "Error");
                    return;
                }
                
                // Validate the template data
                try {
                    JSON.parse(currentState);
                } catch (parseError) {
                    console.error('Invalid template data:', parseError);
                    alert("Invalid template data found", "Error");
                    return;
                }
                
                console.log('Saving template with name:', state.templateName, 'and data:', currentState);
                
                let existingTemplate = templates.find(x => x.templateName === state.templateName);
                if (existingTemplate) {
                    let updateTemplate = confirm("<i>The template name already exists do you want to overwrite this template?</i>", "Confirm template overwrite");
                    updateTemplate.then(async (dialogResult) => {
                        if (dialogResult) {
                            await updateGridTemplateConfiguration(existingTemplate.id);
                        }
                    });
                }
                else {
                    await postGridTemplate(state.templateName, userId, programId, categoryId, currentState);
                    await getGridData();
                    alert("Template saved successfully", "Success");
                }
            } catch (error) {
                console.error('Error saving template:', error);
                alert("Failed to save template", "Error");
            }
        }
        setState({ ...state, templateName: "" })
    }


    const handleCloseDialog = (key, value) => {
        setState({ ...state, open: { ...state.open, [key]: value } });
    }

    const displayTitle = (programId, categoryId) => {

        if (programId === 0 && categoryId === 0){
            return `Templates for Global Grid`;
        }
        const program = programs?.filter(x => x.programId.toString() === programId.toString())[0]?.name
        const category = categories[programId]?.filter(x => x.categoryId === categoryId)[0]?.categoryName;
        return `Templates for Program ${program} category ${category}`;
    }

    const renderRowButtons = (row) => {
        return (
            renderButtons(row, switchTemplate, showShareGridTemplateDialog, updateGridTemplateDialog, showCloneGridTemplateDialog, deleteTemplate)
        );
    }

    const title = displayTitle(programId, categoryId);

    return (
        <div>
            <Popup
                visible={open}
                height={"65vh"}
                width={"40vw"}
                onHiding={() => onClose("saveColumnConfiguration", false)}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                resizeEnabled={false}
                title={title}
            >
                <div>
                    <div>
                        <div className="flex-item" style={{ fontWeight: "bolder", fontSize: "x-large" }}>
                            <span>Current Template: {getCurrentTemplate(templates)}</span>
                        </div>
                        <div className="flex-item">
                            <span>Template Name</span>
                        </div>
                        <div className="flex-item">
                            <TextBox maxLength={100} width={"20vw"} showClearButton={true}
                                value={state.templateName}
                                onValueChanged={valueChanged}
                            />
                        </div>
                        <div className="flex-item">
                            <Button
                                text="Add"
                                onClick={async () => await saveColumnConfiguration()} />
                        </div>
                    </div>
                    {isLoadingData ?
                      <div style={{ paddingTop: "5px" }}>
                          <LinearProgress /> Loading...{" "}
                      </div>
                    :
                      loading ?
                        <div style={{ paddingTop: "5px" }}>
                            <LinearProgress /> Setting template...{" "}
                        </div>
                        :
                        <GridTemplatesGrid templates={templates} deleteTemplate={deleteTemplate} updateGridTemplateName={updateGridTemplateName} renderButtons={renderRowButtons} />
                    }
                </div>
            </Popup >
            <CloneGridTemplateDialog open={state.open.showCloneGridTemplate} onClose={handleCloseDialog} templateId={state.selectedTemplateId} />
            <ShareGridTemplateDialog open={state.open.showShareGridTemplate} onClose={handleCloseDialog} templateId={state.selectedTemplateId} />
        </div >
    );
}

SaveGridTemplateDialog.propTypes = {
    onClose: PropTypes.func,
    onTemplateChange: PropTypes.func,
    open: PropTypes.bool,
    programId: PropTypes.string,
    categoryId: PropTypes.string,
    storageKey: PropTypes.string,
    userId: PropTypes.string,
    gridInstance: PropTypes.object
};

export default SaveGridTemplateDialog;
